import React, { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { QRCode } from 'react-qr-code';
import './diploma.css';
import logo from '../header/images/logo.png';
import ribbondiploma from '../imagesHome/ribbondiploma.png';


import logocontadiploma from '../imagesHome/logoconta.png';

const Diploma = () => {
  const diplomaRef = useRef(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/user`, {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => setUser(data));
  }, []);

  const downloadPDF = async () => {
    const canvas = await html2canvas(diplomaRef.current, {
      scale: 3,
      useCORS: true,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('landscape', 'px', [1123, 794]);
    pdf.addImage(imgData, 'PNG', 0, 0, 1123, 794);
    pdf.save(`${user.username}_diploma.pdf`);
  };

  if (!user) return null;

  const verifyUrl = `https://contalearn.ro/verify/${user.id}`;

  return (
    <div className="diploma-page">
      <div className="diploma-wrapper" ref={diplomaRef}>
        <div className="diploma-outer-border">
          <div className="diploma-border">
            {/* LOGO SUS */}
            <div className="diploma-top-logo">
              <img src={logo} alt="Contalearn" />
            </div>
            <h1 className="diploma-title">Certificat de absolvire</h1>
            <p className="diploma-text">Se acorda prezentul certificat lui</p>
            <h2 className="diploma-name">{user.username}</h2>
            <p className="diploma-text">
              pentru finalizarea cu succes a cursului
            </p>
            <h3 className="diploma-course">Bazele contabilitatii</h3>

              <div className="ribbon-wrapper">
    <img src={ribbondiploma} className="ribbon-diploma" alt="" />
    </div>

          {/* LINIE INFERIOARA: QR | SEMNATURA | BADGE */}
<div className="diploma-bottom-row">

  {/* STANGA – QR */}
  <div className="bottom-col left">
    <div className="verification-area">
      <div className="verification-qr">
        <QRCode
          value={verifyUrl}
          size={64}
          bgColor="#ffffff"
          fgColor="#0f172a"
        />
      </div>

      <div className="verification-info">
        <span className="verify-title">Certificat verificabil online</span>
        <span className="verify-text">
          Scaneaza codul QR sau acceseaza
        </span>
        <span className="verify-link">
          contalearn.ro/verify/{user.id}
        </span>
      </div>
    </div>
  </div>

  {/* MIJLOC – SEMNATURA */}
  <div className="bottom-col center">
    <div className="ceo-signature">
      <span className="signature-line" />
      <span className="signature-name">CEO Contalearn</span>
    </div>
  </div>

  {/* DREAPTA – BADGE */}
<div className="bottom-col right">


    <div className="badge-signature">
      <div className="badge-ring">
        <div className="badge-inner">
          <img src={logocontadiploma} alt="Curs completat" />
        </div>

        <svg className="badge-text-circle" viewBox="0 0 200 200">
          <defs>
            <path
              id="circlePath"
              d="
                M 100, 100
                m -75, 0
                a 75,75 0 1,1 150,0
                a 75,75 0 1,1 -150,0
              "
            />
          </defs>
          <text>
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              CURS ★ COMPLETAT ★ CONTALEARN
            </textPath>
          </text>
        </svg>
      </div>
    </div>
  
</div>

</div>


        


              <div />


       


          
            

          </div>
        </div>
      </div>

      <button className="download-btn" onClick={downloadPDF}>
        Descarca diploma (PDF)
      </button>
    </div>
  );
};

export default Diploma;
